import { apiRequest } from './api';

const API_KEY_ENDPOINTS = {
  CREATE: '/api/keys',
  LIST: '/api/keys',
  USAGE: '/api/keys/usage',
  REVOKE: (id) => `/api/keys/${id}`,
  REVOKE_ALL: '/api/keys'
};

export const apiKeyService = {
  // Create a new API key
  async createApiKey(keyData) {
    const response = await apiRequest('POST', API_KEY_ENDPOINTS.CREATE, keyData);
    return response;
  },

  // Get all API keys for the current user
  async getApiKeys() {
    const response = await apiRequest('GET', API_KEY_ENDPOINTS.LIST);
    return response;
  },

  // Get API key usage statistics
  async getApiKeyUsage() {
    const response = await apiRequest('GET', API_KEY_ENDPOINTS.USAGE);
    return response;
  },

  // Revoke a specific API key
  async revokeApiKey(id) {
    const response = await apiRequest('DELETE', API_KEY_ENDPOINTS.REVOKE(id));
    return response;
  },

  // Revoke all API keys for the current user
  async revokeAllApiKeys() {
    const response = await apiRequest('DELETE', API_KEY_ENDPOINTS.REVOKE_ALL);
    return response;
  }
};
